module.exports = __webpack_public_path__ + "img/hk_shako1.d49f301b.png";